/* Katana Sword — Meta showcase landing. Header/cart/search/menu behaviour comes from the theme's theme.js. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.ms-reveal');
  if (!hasIO || reduce) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---------- counters ---------- */
  function fmt(n, dec) {
    return dec ? n.toFixed(dec) : Math.round(n).toLocaleString('en-US');
  }
  function count(el) {
    var target = parseFloat(el.getAttribute('data-ms-count'));
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (isNaN(target) || reduce) return;
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e, dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target, dec);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-ms-count]');
  if (hasIO) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- videos: responsive source, loop on a segment, lazy start ---------- */
  function pickSrc(v) {
    var w = window.innerWidth * Math.min(window.devicePixelRatio || 1, 2);
    var c = navigator.connection;
    var slow = c && (c.saveData || /2g/.test(c.effectiveType || ''));
    if (slow || w < 900) return v.getAttribute('data-src-sm');
    if (w < 1700) return v.getAttribute('data-src-md') || v.getAttribute('data-src-sm');
    return v.getAttribute('data-src-lg') || v.getAttribute('data-src-md');
  }
  function setupVideo(v) {
    var start = parseFloat(v.getAttribute('data-start') || '0');
    var end = parseFloat(v.getAttribute('data-end') || '0');
    var bar = v.closest('section') && v.closest('section').querySelector('[data-ms-video-progress]');
    v.muted = true;
    v.src = pickSrc(v);
    v.addEventListener('loadedmetadata', function () { if (start > 0) v.currentTime = start; });
    v.addEventListener('timeupdate', function () {
      if (end > 0 && v.currentTime >= end) v.currentTime = start;
      if (bar && end > start) bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, (v.currentTime - start) / (end - start))) + ')';
    });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  document.querySelectorAll('[data-ms-video]').forEach(function (v) {
    if (reduce) return; /* keep the poster */
    if (v.hasAttribute('data-lazy') && hasIO) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!v.src) setupVideo(v); else v.play().catch(function () {});
          } else if (v.src) { v.pause(); }
        });
      }, { rootMargin: '200px 0px' });
      vio.observe(v);
    } else {
      setupVideo(v);
    }
  });


  /* ---------- hero reel: several katanas, cross-faded ---------- */
  (function () {
    var root = document.querySelector('[data-ms-reel]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ms-reel__slide'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-ms-reel-nav] .ms-reel__chip'));
    if (!slides.length) return;
    var cur = -1, raf = null, t0 = 0, failed = false;

    function prep(i) {
      var s = slides[i];
      if (!s || s.getAttribute('data-type') !== 'video') return;
      var v = s.querySelector('video');
      if (v.src) return;
      v.muted = true; v.preload = 'auto';
      v.src = pickSrc(v);
      var start = parseFloat(s.getAttribute('data-start') || '0');
      v.addEventListener('loadedmetadata', function () { try { v.currentTime = start; } catch (e) {} }, { once: true });
    }
    function setChips(i, p) {
      chips.forEach(function (c, k) {
        c.classList.toggle('is-active', k === i);
        c.classList.toggle('is-done', k < i);
        var bar = c.querySelector('.ms-reel__bar span');
        if (bar) bar.style.transform = k === i ? 'scaleX(' + p + ')' : (k < i ? 'scaleX(1)' : 'scaleX(0)');
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      var prev = slides[cur];
      cur = i;
      var s = slides[i];
      cancelAnimationFrame(raf);
      slides.forEach(function (x) { x.classList.toggle('is-active', x === s); });
      if (prev && prev !== s) {
        var pv = prev.querySelector('video');
        if (pv) setTimeout(function () { pv.pause(); }, 900);
      }
      prep(i + 1);
      if (s.getAttribute('data-type') === 'video' && !failed && !reduce) {
        var v = s.querySelector('video');
        prep(i);
        var start = parseFloat(s.getAttribute('data-start') || '0');
        var end = parseFloat(s.getAttribute('data-end') || '0') || 6;
        if (v.readyState >= 1 && Math.abs(v.currentTime - start) > 0.3) { try { v.currentTime = start; } catch (e) {} }
        var p = v.play();
        if (p && p.catch) p.catch(function () { failed = true; });
        var tick = function () {
          var t = v.currentTime;
          if (t < start - 0.5 && v.readyState >= 1) { try { v.currentTime = start; } catch (e) {} }
          var pr = Math.max(0, Math.min(1, (t - start) / (end - start)));
          setChips(i, pr);
          if (t >= end - 0.12) { go(i + 1); return; }
          if (failed && performance.now() - t0 > 5000) { go(i + 1); return; }
          raf = requestAnimationFrame(tick);
        };
        t0 = performance.now();
        raf = requestAnimationFrame(tick);
      } else {
        var dur = (parseFloat(s.getAttribute('data-duration')) || 5) * 1000;
        var st = performance.now();
        var tickI = function (now) {
          var pr = Math.min(1, (now - st) / dur);
          setChips(i, pr);
          if (pr >= 1) { go(i + 1); return; }
          raf = requestAnimationFrame(tickI);
        };
        raf = requestAnimationFrame(tickI);
      }
    }
    chips.forEach(function (c, k) {
      var a = c.querySelector('[data-ms-reel-go]');
      if (a) a.addEventListener('click', function (e) {
        if (k !== cur) { e.preventDefault(); go(k); }
      });
    });
    document.addEventListener('visibilitychange', function () {
      var s = slides[cur]; var v = s && s.querySelector('video');
      if (!v) return;
      if (document.hidden) v.pause(); else v.play().catch(function () {});
    });
    go(0);
  })();


  /* ---------- custom katana: cycle finishes ---------- */
  document.querySelectorAll('[data-ms-custom]').forEach(function (root) {
    var frames = root.querySelectorAll('.ms-custom__frame');
    var sws = root.querySelectorAll('.ms-sw');
    if (frames.length < 2 || reduce) return;
    var i = 0, timer = null;
    function show(n) {
      i = n % frames.length;
      frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      sws.forEach(function (w, k) { w.classList.toggle('is-active', k === i); });
    }
    function start() { if (!timer) timer = setInterval(function () { show(i + 1); }, 2600); }
    function stop() { clearInterval(timer); timer = null; }
    if (hasIO) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? start() : stop(); }); }, { threshold: 0.2 }).observe(root);
    } else start();
  });

  /* ---------- light parallax ---------- */
  var par = Array.prototype.slice.call(document.querySelectorAll('[data-ms-parallax]'));
  var drift = Array.prototype.slice.call(document.querySelectorAll('[data-ms-drift]'));
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      par.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-ms-parallax')) || 0;
        var offset = (r.top + r.height / 2 - vh / 2) * -k;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      drift.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-ms-drift')) || 0;
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.translate = (prog * k * 6).toFixed(2) + '% 0';
      });
      ticking = false;
    });
  }
  if (!reduce && (par.length || drift.length)) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- rail progress bars ---------- */
  document.querySelectorAll('[data-ms-rail]').forEach(function (rail) {
    var section = rail.closest('section');
    var bar = section && section.querySelector('[data-ms-rail-bar]');
    if (!bar) return;
    function upd() {
      var max = rail.scrollWidth - rail.clientWidth;
      var track = bar.parentElement.clientWidth - 2 * parseFloat(getComputedStyle(bar).left || 0);
      var ratio = rail.clientWidth / Math.max(rail.scrollWidth, 1);
      var w = Math.max(0.12, Math.min(1, ratio)) * track;
      bar.style.width = w + 'px';
      bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * (track - w) : 0) + 'px)';
      bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
    }
    rail.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  });

  /* ---------- tabs ---------- */
  document.querySelectorAll('[data-ms-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var ink = root.querySelector('[data-ms-ink]');
    function moveInk(tab) {
      if (!ink || !tab) return;
      ink.style.width = tab.offsetWidth + 'px';
      ink.style.height = tab.offsetHeight + 'px';
      ink.style.transform = 'translate(' + tab.offsetLeft + 'px,' + tab.offsetTop + 'px)';
    }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; panel.classList.toggle('is-active', on); }
      });
      moveInk(tab);
      if (focus) tab.focus();
      /* lazysizes: make sure images in the newly shown panel load */
      if (window.lazySizes && window.lazySizes.autoSizer) { window.lazySizes.autoSizer.checkElems(); }
      window.dispatchEvent(new Event('scroll'));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    var current = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    moveInk(current);
    window.addEventListener('resize', function () {
      moveInk(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInk(current); });
  });
})();
